import { render } from "./BaseSpinner.vue?vue&type=template&id=486e31e8"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=486e31e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__